const ArrowOutwardIcon = () => {
    return (
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.4 13.207L0 11.807L9.6 2.20703H1V0.207031H13V12.207H11V3.60703L1.4 13.207Z" fill="white" />
        </svg>

    );
};
export default ArrowOutwardIcon;